import { useFileSignedUrl } from "@/api/services/global/file";
import { IconClose, IconPerson } from "@/assets/icons";
import { SafeLazyLoadImage } from "@/components/elements/Avatar/SafeLazyLoadImage";
import { IconBox } from "@/components/elements/IconBox";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { background, divider } from "@/theme/colors";
import { AvatarProps, Box, Stack, styled } from "@mui/material";
import { FC } from "react";

type TAvatarProps = {
  width: number;
  height: number;
  filePath?: string | null;
  imageSrc?: string | null;
  onRemove?: () => void;
} & Omit<AvatarProps, "src">;

export const Avatar: FC<TAvatarProps> = ({ width, height, filePath, imageSrc, sx, onRemove, ...rest }) => {
  const { data: infoResult, isLoading } = useFileSignedUrl(filePath);

  if (!filePath && !imageSrc) {
    return (
      <AvatarArea width={width} height={height} sx={sx} {...rest}>
        <IconPerson fontSize={100} color="#CACDCD" width={80} height={80} />
      </AvatarArea>
    );
  }

  return (
    <AvatarWrapper>
      {isLoading ? (
        <LoadingArea width={width} height={height} />
      ) : (
        <SafeLazyLoadImage effect="blur" height={height} width={width} src={(imageSrc || infoResult?.data.signedUrl) ?? undefined} />
      )}
      {!!onRemove && (
        <IconBox
          size={24}
          sx={{
            position: "absolute",
            top: "-5px",
            right: "-30px",
          }}
          onClick={onRemove}
        >
          <IconClose />
        </IconBox>
      )}
    </AvatarWrapper>
  );
};

const AvatarWrapper = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    object-fit: contain;
  }
`;

const AvatarArea = styled(Stack)`
  background-color: ${background.white};
  align-items: center;
  justify-content: center;
  border: 1px dashed ${divider.middle};
  border-radius: 2px;
`;
